import * as types from './types'

export default {
  [types.MUTATE_WHATS_NEW_SEARCH_RESULT]: (state, value) => {
    state.searchResult = value
  },
  [types.MUTATE_WHATS_NEW_HISTORY]: (state, value) => {
    state.history = value
  },
  [types.MUTATE_WHATS_NEW_MODAL]: (state, value) => {
    state.modal = { ...state.modal, ...value }
  },
}
